
export enum SetPointVarianceTypeEnum {
    Either = 0,
    Increase = 1,
    Decrease = 2,
}

